/**
 * Service implementation to provide Ping functionality.
 * <P>
 * Intended to provide basic Ping functionality by immediately responding to a
 * received request, by which the round-trip latency between the sender and
 * receiver may be ascertained.
 * 
 * @module services/Ping
 */
var service = {
    /**
     * Handle an inbound request.
     * 
     * @param {InternalSession} internal - The internal session instance
     * @param {Object} [ping=null] - The inbound ping request
     * @param {Function} callback - The service reference callback 
     */
    onRequest : function(internal, ping, callback) {
        callback.respond();
    }
};

module.exports = service;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/client/services/ping-service.js
// module id = 975
// module chunks = 1